import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { Config } from '../app.configs';

@Injectable({
  providedIn: 'root'
})
export class RevolupayService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getInfo(uuid: string): Observable<any> {
    const headers = this.authService.getHeaders()

    return this.http.get<any>(
      Config.toApiUrl(`dashboard/users/${uuid}/revolupay/`), { headers, withCredentials: true }
    );
  }

  addAccess(uuid: string): Observable<any> {
    const headers = this.authService.getHeaders();

    return this.http.post(
      Config.toApiUrl(`dashboard/users/${uuid}/revolupay/`),
      {},
      { headers, withCredentials: true },
    );
  }

}
